// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'variable';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M10.368 6.192v2.52c0 1.224 1.008 2.232 2.232 2.232s2.232-1.008 2.232-2.232v-2.52m-.936 4.392-3.528 3.528m-2.592-7.92-4.752 4.752m0-4.752 4.752 4.752'
  />
);

export const viewBox = '0 0 18 18';
